import React, { useState } from 'react'
import classes from "./styles/faq.module.css";
import minus from "./dumble.png";
import plus from "./dumble.png";
import { useNavigate } from 'react-router-dom';

// import plus from "../../../assets/faq/plus.png";

const Faq4 = () => {
    const [box1 , setBox1] = useState(false);
    const [box2 , setBox2] = useState(false);
    const [box3 , setBox3] = useState(false);
    const navigate = useNavigate();

    const handlebox1 = () => {
        setBox1(!box1);
    }
    const handlebox2 = () => {
        setBox2(!box2);
    }

    const handlebox3 = () => {
        setBox3(!box3);
    }
    // const handlebox4 = () => {
    //     setBox4(!box4);
    // }

    const scrollToContact = () => {
        const element = document.getElementById("DiscoveryCallSection");
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }else{
          navigate("/");
          const delayImport = () => {
            const element2 = document.getElementById("DiscoveryCallSection");
            element2.scrollIntoView({ behavior: 'smooth' });
          };
          const timeoutId = setTimeout(() => {
            delayImport();
          }, 300);
          return () => clearTimeout(timeoutId);
        }
      };

  return (
    <div className={classes.Container}>
      <div className={box1 ? classes.boxOpen2 : classes.box} onClick={handlebox1}>
            <div className={classes.upperCon}>
                <div>How will my progress be tracked?</div>
                <div className={`${classes.logoCon} ${box1 ? classes.rotateIcon : ''}`}><img src={box1 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>We will ship a personal journal for you to maintain which is intended for overall development and goals alignment. We
                    will monitor the progress through your <b>journal entries, weekly check-ins, progress photos, and personalized
                    feedback</b> to keep you accountable.</div>
            </div>
        </div>


        <div className={box2 ? classes.boxOpen : classes.box} onClick={handlebox2}>
            <div className={classes.upperCon}>
                <div>What if I need help during the program?</div>
                <div className={`${classes.logoCon} ${box2 ? classes.rotateIcon : ''}`}><img src={box2 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>You get <b>direct access to Susmita via WhatsApp</b>, for focused and personalized guidance.</div>
            </div>
        </div>



        <div className={box3 ? classes.boxOpen : classes.box} onClick={handlebox3}>
            <div className={classes.upperCon}>
                <div>How do I get started?</div>
                <div className={`${classes.logoCon} ${box3 ? classes.rotateIcon : ''}`}><img src={box3 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Click <b onClick={scrollToContact}>[Book a Free Discovery Call]</b> to discuss your goals and begin your transformation!</div>
            </div>
        </div>

        {/* <div className={box4 ? classes.boxOpen : classes.box} onClick={handlebox4}>
            <div className={classes.upperCon}>
                <div>What if I miss a workout or have a busy week?</div>
                <div className={`${classes.logoCon} ${box4 ? classes.rotateIcon : ''}`}><img src={box4 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Life happens! The program is flexible, and you’ll receive guidance on how to stay on track even during busy times.</div>
            </div>
        </div> */}
    </div>
  )
}

export default Faq4;
